import { useRef, useState } from "react";
import styled, { keyframes } from "styled-components";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import useDisplay from "../../../hooks/useDisplay";
import { fileUrl } from "../../../api/api";
import { route } from "../../../router/route";
import { useNavigate } from "react-router-dom";
import LSRgH1HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import PCContainer from "../../atoms/layout/pcContainer";
import { openSafeLink } from "../../../util/openSafeLink";

function BannerSwiper({ bannerList = [], setIsOnboardingModal }) {
  const navigate = useNavigate();
  const swiperRef = useRef();

  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const [activeIndex, setActiveIndex] = useState(0);
  const topMenuList = [
    {
      title: "맞춤 추천 온보딩",
      activeImage: "/assets/icons/solar_clipboard_a.png",
      deActiveImage: "/assets/icons/solar_clipboard_d.png",
    },
    {
      title: "금융 스터디",
      activeImage: "/assets/icons/bxs_book_a.png",
      deActiveImage: "/assets/icons/bxs_book_d.png",
      src: route.study_list,
    },
    {
      title: "영상 강의",
      activeImage: "/assets/icons/ph_video_a.png",
      deActiveImage: "/assets/icons/ph_video_d.png",
      src: route.lecture_list,
    },
    {
      title: "금융 칼럼",
      activeImage: "/assets/icons/solar_chat_a.png",
      deActiveImage: "/assets/icons/solar_chat_d.png",
      src: route.column_list,
    },
    {
      title: "커뮤니티",
      activeImage: "/assets/icons/streamline_chat_a.png",
      deActiveImage: "/assets/icons/streamline_chat_d.png",
      src: route.community_list,
    },
    {
      title: "1:1 컨설팅",
      activeImage: "/assets/icons/streamline_information_a.png",
      deActiveImage: "/assets/icons/streamline_information_d.png",
      src: route.consulting,
    },
  ];
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <>
      <div
        style={{
          width: "100%",
          position: "relative",
          minHeight: bannerList.length === 0 ? (isMobile ? 236 : 164) : 0,
        }}
      >
        <Swiper
          modules={[Autoplay, Navigation]}
          onSwiper={(it) => {
            swiperRef.current = it;
          }}
          slidesPerView={1}
          centeredSlides={true}
          spaceBetween={0}
          onSlideChange={(swiper) => {
            setActiveIndex(swiper.realIndex);
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {bannerList?.length > 0
            ? bannerList?.map((item, index) => {
                return (
                  <SwiperSlide key={item.id ?? index}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        flex: 1,
                        width: "100%",
                        height: isMobile
                          ? "auto"
                          : isTablet
                            ? "310px"
                            : "500px",
                        position: "relative",
                      }}
                    >
                      <img
                        onClick={() => {
                          openSafeLink(item.link, item.newOpen);
                        }}
                        style={{
                          cursor: item.link ? "pointer" : "default",
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        src={
                          isMobile
                            ? `${fileUrl}/${item.imageServerFileNameMo}`
                            : `${fileUrl}/${item.imageServerFileNamePc}`
                        }
                        alt={item.title || "메인 배너"}
                      />
                    </div>
                  </SwiperSlide>
                );
              })
            : null}
        </Swiper>

        {isSmall ? null : (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              position: "absolute",
              bottom: 113,
              left: "19%",
              zIndex: 4,
            }}
          >
            {bannerList.map((item02, index02) => {
              return (
                <div
                  key={index02}
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: 99,
                    background:
                      index02 === activeIndex
                        ? "#ffffff"
                        : "rgba(255, 255, 255, 0.2)",
                    marginRight: 6,
                  }}
                />
              );
            })}
          </div>
        )}

        <SlideUpWrapper isMobile={isMobile}>
          <PCContainer
            style={{
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              padding: isSmall ? "0px 20px" : "0px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "space-between",
                position: "relative",
                background: "#FFFFFF",
                borderRadius: 30,
                boxShadow: "0px 3px 4px 0px #0000001A",
                height: isMobile ? 236 : 164,
                width: "100%",
                zIndex: 10,
                padding: isMobile
                  ? "0px 15px"
                  : isTablet
                    ? "0px 40px"
                    : "0px 120px",
              }}
            >
              {topMenuList.map((item, index) => {
                return (
                  <div
                    onClick={() => {
                      if (item.src) {
                        navigate(item.src);
                      } else {
                        setIsOnboardingModal();
                      }
                    }}
                    key={item.title}
                    style={{
                      display: "flex",
                      cursor: "pointer",
                      flexDirection: "column",
                      alignItems: "center",
                      position: "relative",
                      width: isMobile ? "30%" : 102,
                    }}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                  >
                    <AnimatedImage
                      isMobile={isMobile}
                      isHovered={hoveredIndex === index}
                      src={
                        hoveredIndex === index
                          ? item.activeImage
                          : item.deActiveImage
                      }
                      alt="menu-item"
                    />

                    <LSRgH1HeadLine
                      style={{
                        color: "#000000",
                        textAlign: "center",
                        fontSize: isMobile ? 14 : 16,
                        lineHeight: isMobile ? "19.6px" : "22.4px",
                      }}
                    >
                      {item.title}
                    </LSRgH1HeadLine>

                    {index === 2 ? (
                      <BouncingImage
                        src={"/assets/icons/premium.png"}
                        alt="premium"
                      />
                    ) : null}
                  </div>
                );
              })}
            </div>
          </PCContainer>
        </SlideUpWrapper>
      </div>
    </>
  );
}

export default BannerSwiper;

const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
`;

const BouncingImage = styled.img`
  position: absolute;
  width: 91px;
  height: 42px;
  top: -40px;
  animation: ${bounce} 2s infinite;
`;

// 아래에서 위로 올라오는 애니메이션 정의
const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

// 애니메이션이 적용된 래퍼 스타일
const SlideUpWrapper = styled.div`
  position: absolute;
  width: 100%;
  bottom: ${(props) => (props.isMobile ? "-200px" : "-90px")};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  animation: ${slideUp} 0.7s ease-out;
  z-index: 4;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 1;
  }
`;

const AnimatedImage = styled.img`
  width: ${(props) => (props.isMobile ? "30px" : "48px")};
  height: ${(props) => (props.isMobile ? "30px" : "48px")};
  margin-bottom: 20px;
  transition: opacity 0.7s ease-in-out;
  animation: ${(props) => (props.isHovered ? fadeIn : fadeOut)} 0.7s ease-in-out;
  opacity: ${(props) => (props.isHovered ? 1 : 1)};
`;
